import { Callout, SelectField, Spinner } from '@humanforce/mango-ui-react';
import { createTenantPayTypesClient } from '@pay-roadrunner/pay-types-ui';
import { createRegionsClient } from '@pay-roadrunner/regions-ui';
import { useEffect, useState } from 'react';
import { authFetch } from '../../auth/authFetch';
import { getApiBaseUrl } from '../../auth/api';
import { fetchOrganisations } from '../organisation/organisationHttpClient';
import { PayTypesCatalogueScreen } from './PayTypesCatalogueScreen';

const apiClientDeps = { getBaseUrl: getApiBaseUrl, fetchImpl: authFetch };
const regionsClient = createRegionsClient(apiClientDeps);
const payTypesClient = createTenantPayTypesClient(apiClientDeps);

export const PAY_TYPES_PANEL_HOST_ID = 'configuration-pay-types-panel';

export const OrganisationPayTypesTab = ({ onPanelVisibilityChange }: { onPanelVisibilityChange: (visible: boolean) => void }) => {
  const [options, setOptions] = useState<Array<{ label: string; value: string }>>([]);
  const [organisationId, setOrganisationId] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    void fetchOrganisations().then((response) => {
      if (!active) return;
      if (!response.success) throw new Error(response.message || 'Organisations could not be loaded.');
      const found = (response.result ?? []).flatMap((organisation) => organisation.id
        ? [{ value: organisation.id, label: organisation.displayName || organisation.id }] : []);
      setOptions(found);
      setOrganisationId(found[0]?.value ?? '');
    }).catch((failure) => { if (active) setError(failure instanceof Error ? failure.message : 'Organisations could not be loaded.'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  if (loading) return <div className="mgo-cluster mgo-gap-s" aria-busy="true"><Spinner /><span>Loading Organisations...</span></div>;
  if (error) return <Callout tone="critical" title="Organisations unavailable">{error}</Callout>;
  if (options.length === 0) return <Callout tone="neutral" title="No Organisations">Create an Organisation before managing Pay Types.</Callout>;

  return <div className="mgo-stack mgo-gap-l">
    <div className="mgo-max-width-s"><SelectField label="Organisation" options={options} value={organisationId} searchable={false}
      onChange={(value) => { onPanelVisibilityChange(false); setOrganisationId(typeof value === 'string' ? value : ''); }} /></div>
    {organisationId && <PayTypesCatalogueScreen key={organisationId} client={payTypesClient} regionsClient={regionsClient} organisationId={organisationId}
      panelHostId={PAY_TYPES_PANEL_HOST_ID} onPanelVisibilityChange={onPanelVisibilityChange} />}
  </div>;
};
